import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { subGroupClubGallery } from './subGroupClubGallery.types';

export const getSubGroupClubGallery = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<subGroupClubGallery[]>>('/sub-group-club-gallery')).data;
};

export const subGroupClubGalleryQueries = {
  all: () => ['sub-group-club-gallery'],
  list: () =>
    queryFactoryOptions<ApiResponse<subGroupClubGallery[]>>({
      queryKey: [...subGroupClubGalleryQueries.all(), 'list'],
      queryFn: (client: AxiosInstance) => getSubGroupClubGallery(client),
    }),
};
